"use strict";
// Copyright 2022 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.ExperienceType = exports.ChangeEventName = exports.WarnChangeEventName = exports.ErrorChangeEventName = exports.InfoChangeEventName = exports.ChangeEventLevel = exports.MessageEventName = exports.InvokerMessageEventName = exports.GetterMessageEventName = exports.SetterMessageEventName = exports.InfoMessageEventName = void 0;
var InfoMessageEventName;
(function (InfoMessageEventName) {
    InfoMessageEventName["CALLBACK_OPERATION_INVOKED"] = "CALLBACK_OPERATION_INVOKED";
    InfoMessageEventName["CONTENT_LOADED"] = "CONTENT_LOADED";
    InfoMessageEventName["EXPERIENCE_INITIALIZED"] = "EXPERIENCE_INITIALIZED";
    InfoMessageEventName["ERROR_OCCURRED"] = "ERROR_OCCURRED";
    InfoMessageEventName["SIZE_CHANGED"] = "SIZE_CHANGED";
    InfoMessageEventName["PARAMETERS_CHANGED"] = "PARAMETERS_CHANGED";
    InfoMessageEventName["SELECTED_SHEET_CHANGED"] = "SELECTED_SHEET_CHANGED";
    InfoMessageEventName["MODAL_OPENED"] = "MODAL_OPENED";
    InfoMessageEventName["Q_SEARCH_CLOSED"] = "Q_SEARCH_CLOSED";
    InfoMessageEventName["Q_SEARCH_OPENED"] = "Q_SEARCH_OPENED";
    InfoMessageEventName["Q_SEARCH_SIZE_CHANGED"] = "Q_SEARCH_SIZE_CHANGED";
    InfoMessageEventName["Q_SEARCH_ENTERED_FULLSCREEN"] = "Q_SEARCH_ENTERED_FULLSCREEN";
    InfoMessageEventName["Q_SEARCH_EXITED_FULLSCREEN"] = "Q_SEARCH_EXITED_FULLSCREEN";
})(InfoMessageEventName = exports.InfoMessageEventName || (exports.InfoMessageEventName = {}));
var SetterMessageEventName;
(function (SetterMessageEventName) {
    SetterMessageEventName["SET_PARAMETERS"] = "SET_PARAMETERS";
    SetterMessageEventName["SET_SELECTED_SHEET_ID"] = "SET_SELECTED_SHEET_ID";
    SetterMessageEventName["SET_Q_SEARCH_QUESTION"] = "SET_Q_SEARCH_QUESTION";
    SetterMessageEventName["SET_CONTENT_OPTIONS"] = "SET_CONTENT_OPTIONS";
    SetterMessageEventName["SET_VISUAL_ACTIONS"] = "SET_VISUAL_ACTIONS";
    SetterMessageEventName["ADD_VISUAL_ACTIONS"] = "ADD_VISUAL_ACTIONS";
    SetterMessageEventName["REMOVE_VISUAL_ACTIONS"] = "REMOVE_VISUAL_ACTIONS";
})(SetterMessageEventName = exports.SetterMessageEventName || (exports.SetterMessageEventName = {}));
var GetterMessageEventName;
(function (GetterMessageEventName) {
    GetterMessageEventName["GET_PARAMETERS"] = "GET_PARAMETERS";
    GetterMessageEventName["GET_SHEETS"] = "GET_SHEETS";
    GetterMessageEventName["GET_SHEET_VISUALS"] = "GET_SHEET_VISUALS";
    GetterMessageEventName["GET_VISUAL_ACTIONS"] = "GET_VISUAL_ACTIONS";
    GetterMessageEventName["GET_SELECTED_SHEET_ID"] = "GET_SELECTED_SHEET_ID";
})(GetterMessageEventName = exports.GetterMessageEventName || (exports.GetterMessageEventName = {}));
var InvokerMessageEventName;
(function (InvokerMessageEventName) {
    InvokerMessageEventName["ACKNOWLEDGE"] = "ACKNOWLEDGE";
    InvokerMessageEventName["INITIATE_PRINT"] = "INITIATE_PRINT";
    InvokerMessageEventName["NAVIGATE_TO_DASHBOARD"] = "NAVIGATE_TO_DASHBOARD";
    InvokerMessageEventName["CLOSE_Q_SEARCH"] = "CLOSE_Q_SEARCH";
    InvokerMessageEventName["UNDO"] = "UNDO";
    InvokerMessageEventName["REDO"] = "REDO";
    InvokerMessageEventName["RESET"] = "RESET";
    InvokerMessageEventName["TOGGLE_BOOKMARKS_PANE"] = "TOGGLE_BOOKMARKS_PANE";
})(InvokerMessageEventName = exports.InvokerMessageEventName || (exports.InvokerMessageEventName = {}));
exports.MessageEventName = __assign(__assign(__assign(__assign({}, InfoMessageEventName), SetterMessageEventName), GetterMessageEventName), InvokerMessageEventName);
var ChangeEventLevel;
(function (ChangeEventLevel) {
    ChangeEventLevel["ERROR"] = "ERROR";
    ChangeEventLevel["INFO"] = "INFO";
    ChangeEventLevel["WARN"] = "WARN";
})(ChangeEventLevel = exports.ChangeEventLevel || (exports.ChangeEventLevel = {}));
var InfoChangeEventName;
(function (InfoChangeEventName) {
    InfoChangeEventName["FRAME_STARTED"] = "FRAME_STARTED";
    InfoChangeEventName["FRAME_MOUNTED"] = "FRAME_MOUNTED";
    InfoChangeEventName["FRAME_LOADED"] = "FRAME_LOADED";
})(InfoChangeEventName = exports.InfoChangeEventName || (exports.InfoChangeEventName = {}));
var ErrorChangeEventName;
(function (ErrorChangeEventName) {
    ErrorChangeEventName["FRAME_NOT_CREATED"] = "FRAME_NOT_CREATED";
    ErrorChangeEventName["NO_BODY"] = "NO_BODY";
    ErrorChangeEventName["NO_CONTAINER"] = "NO_CONTAINER";
    ErrorChangeEventName["INVALID_CONTAINER"] = "INVALID_CONTAINER";
    ErrorChangeEventName["NO_URL"] = "NO_URL";
    ErrorChangeEventName["INVALID_URL"] = "INVALID_URL";
    ErrorChangeEventName["NO_FRAME_OPTIONS"] = "NO_FRAME_OPTIONS";
    ErrorChangeEventName["INVALID_FRAME_OPTIONS"] = "INVALID_FRAME_OPTIONS";
})(ErrorChangeEventName = exports.ErrorChangeEventName || (exports.ErrorChangeEventName = {}));
var WarnChangeEventName;
(function (WarnChangeEventName) {
    WarnChangeEventName["UNRECOGNIZED_CONTENT_OPTIONS"] = "UNRECOGNIZED_CONTENT_OPTIONS";
    WarnChangeEventName["UNRECOGNIZED_FRAME_OPTIONS"] = "UNRECOGNIZED_FRAME_OPTIONS";
    WarnChangeEventName["UNRECOGNIZED_EVENT_TARGET"] = "UNRECOGNIZED_EVENT_TARGET";
})(WarnChangeEventName = exports.WarnChangeEventName || (exports.WarnChangeEventName = {}));
exports.ChangeEventName = __assign(__assign(__assign({}, InfoChangeEventName), ErrorChangeEventName), WarnChangeEventName);
var ExperienceType;
(function (ExperienceType) {
    ExperienceType["CONSOLE"] = "CONSOLE";
    ExperienceType["CONTEXT"] = "CONTEXT";
    ExperienceType["CONTROL"] = "CONTROL";
    ExperienceType["VISUAL"] = "VISUAL";
    ExperienceType["DASHBOARD"] = "DASHBOARD";
    ExperienceType["QSEARCH"] = "QSEARCH";
})(ExperienceType = exports.ExperienceType || (exports.ExperienceType = {}));
